import { Button, Flex, Link, Text } from '@/ui';

type Props = {
  calendarName: string;
  calendarHref?: string;
  isDisabled: boolean;
  onUnsubscribe: () => void;
};

export const CalendarSubscriptionRow = ({
  calendarName,
  calendarHref,
  isDisabled,
  onUnsubscribe,
}: Props) => (
  <Flex
    align="baseline"
    bg="magicPurple.50"
    borderRadius="ah-lg"
    columnGap={2}
    flexWrap="wrap"
    px={3}
    py={2}
    rowGap={0.5}
  >
    <Text
      color="magicPurple.700"
      fontSize="ah-row"
      fontWeight={700}
      noOfLines={1}
    >
      🎉 {calendarName}
    </Text>
    {calendarHref && (
      <>
        <Text color="magicPurple.300">·</Text>
        <Link
          color="magicPurple.600"
          fontSize="ah-status"
          fontWeight={700}
          href={calendarHref}
          isExternal
          textDecoration="underline"
          textUnderlineOffset="3px"
        >
          Go to calendar
        </Link>
      </>
    )}
    <Text color="magicPurple.300">·</Text>
    <Button
      color="ink.muted"
      fontSize="ah-status"
      fontWeight={600}
      isDisabled={isDisabled}
      textDecoration="underline"
      textUnderlineOffset="3px"
      variant="link"
      onClick={onUnsubscribe}
    >
      Unsubscribe
    </Button>
  </Flex>
);
